import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import InfoIcon from '../shared/InfoIcon';

export default class ProductsIndex extends React.Component {
  static propTypes = {
    accountPlatformUseCaseList: PropTypes.object.isRequired,
    header: PropTypes.string,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isTechnicalProvider: PropTypes.bool.isRequired,
    subscribePlatformUseCaseFunction: PropTypes.func.isRequired,
    unSubscribePlatformUseCaseFunction: PropTypes.func.isRequired,
    useCases: PropTypes.object.isRequired,
  };

  static defaultProps = {
    header: null,
  };

  state = {
    isEditMode: false,
  };

  // Helper function to check if the platform use is subscribed by searching the subscription list
  getDefaultCheckedStatus = platformUseCase => {
    const { accountPlatformUseCaseList } = this.props;
    const platformUseCaseArray = platformUseCase.split(',', 2);
    const platformCodeString = platformUseCaseArray[0].trim();
    const useCaseCodeString = platformUseCaseArray[1].trim();
    const result = accountPlatformUseCaseList.find(
      acctPUC =>
        acctPUC.platform.code === platformCodeString && acctPUC.useCase.code === useCaseCodeString
    );
    // If value was found then the platform use case is subscribed, so return true to marked checked
    if (result) {
      return true;
    }
    return false;
  };

  // useCases can be set when the new platforms are available
  // currently just SFDC and MARKETO are available and set
  platforms = [
    { id: 0, code: 'SFDC', description: 'Salesforce CRM', useCases: [0, 1, 2, 3] },
    { id: 1, code: 'MARKETO', description: 'Marketo', useCases: [0, 2, 3] },
    { id: 2, code: 'ELOQUA', description: 'Oracle Eloqua', useCases: [0, 2, 3] },
    { id: 3, code: 'HUBSPOT', description: 'HubSpot', useCases: [0, 1, 2, 3] },
    { id: 4, code: 'CSV', description: 'CSV', useCases: [0, 1, 2, 3] },
    { id: 5, code: 'DYNAMICS', description: 'Dynamics CRM', useCases: [0, 1, 2, 3] },
    { id: 6, code: 'NETSUITE', description: 'NetSuite', useCases: [] },
    { id: 7, code: 'SUGAR', description: 'SugarCRM', useCases: [] },
  ];

  isUseCaseDisabled = (platform, useCaseId) => {
    const index = platform.useCases.indexOf(useCaseId);
    return index < 0;
  };

  toggleForm = () => {
    const { isEditMode } = this.state;

    if (isEditMode) {
      this.setState({ isEditMode: false });
    } else {
      this.setState({ isEditMode: true });
    }
  };

  // Subscribes/Un-subscribes clicked platform use case
  catchClick = event => {
    const { subscribePlatformUseCaseFunction, unSubscribePlatformUseCaseFunction } = this.props;
    const arrayString = event.target.value;
    const clickArray = arrayString.split(',', 2);
    const platformCode = clickArray[0].trim();
    const useCaseCode = clickArray[1].trim();

    if (event.target.checked) {
      subscribePlatformUseCaseFunction(platformCode, useCaseCode);
    } else {
      unSubscribePlatformUseCaseFunction(platformCode, useCaseCode);
    }
  };

  renderUseCases = (item, index) => {
    const { isSuperAdmin } = this.props;
    return (
      <th key={index}>
        {item.description}&nbsp;
        {item.definition && !isSuperAdmin ? <InfoIcon infoMessage={item.definition} /> : null}
      </th>
    );
  };

  // ignore warning: ProductsIndex is changing a controlled input of type
  // checkbox to be uncontrolled. https://github.com/facebook/react/issues/6779
  // This looks ugly but is simple -->
  // if the platform use case is subscribed then it should be checked
  // UPDATE: this is fixed by changing onClicked, to onChange

  // Note: DMP is a placeholder for now, and is disabled
  renderPlatforms = (item, index) => {
    const { useCases } = this.props;
    const { isEditMode } = this.state;
    return (
      <tr key={index}>
        <th scope="row">{item.description}</th>
        {isEditMode
          ? useCases.map((useCase, i) => this.renderEditUseCaseItems(useCase, item, i))
          : useCases.map(useCase => this.renderUseCaseItems(useCase, item))}
      </tr>
    );
  };

  renderEditUseCaseItems = (useCase, item, index) => {
    if (useCase.code === '') {
      return null;
    }
    const useCaseDisabled = this.isUseCaseDisabled(item, index);
    return (
      <td key={useCase.code}>
        <input
          type="checkbox"
          checked={this.getDefaultCheckedStatus(`${item.code},${useCase.code}`)}
          disabled={useCaseDisabled}
          value={`${item.code}, ${useCase.code}`}
          onChange={this.catchClick}
        />
      </td>
    );
  };

  renderUseCaseItems = (useCase, item) => {
    if (useCase.code === '') {
      return null;
    }
    return (
      <td key={useCase.code}>
        {this.getDefaultCheckedStatus(`${item.code},${useCase.code}`) ? (
          <i className="fa fa-check" />
        ) : null}
      </td>
    );
  };

  renderButtons = isEditMode => (
    <span className="pull-right">
      {isEditMode ? (
        <span>
          <button type="button" className="btn btn-primary" onClick={this.toggleForm}>
            Done
          </button>
        </span>
      ) : (
        <button type="button" className="btn btn-primary" onClick={this.toggleForm}>
          Edit
        </button>
      )}
    </span>
  );

  renderInfoTooltip = () => (
    <ReactTooltip
      id="infoIcon"
      place="right"
      effect="solid"
      delayHide={0}
      offset={{ top: 8 }}
      className="tip"
      type="light"
      border
    />
  );

  render() {
    const { header, isProviderAdmin, isSuperAdmin, isTechnicalProvider, useCases } = this.props;
    const { isEditMode } = this.state;

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-sm-12">
                  <span className="pull-right">
                    {isProviderAdmin || isSuperAdmin || isTechnicalProvider
                      ? this.renderButtons(isEditMode)
                      : null}
                  </span>
                  <h1 className="header-title">{header}</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-8">
              {this.renderInfoTooltip()}
              <table className="table table-center">
                <thead>
                  <tr>
                    <th>Platform</th>
                    {useCases.map(this.renderUseCases)}
                  </tr>
                </thead>
                <tbody>{this.platforms.map(this.renderPlatforms)}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
